import * as enums from './MergeEnums';

export * from './MergeEnums';
export default enums;
